<template>
    <div class="page page-center">
        <img id="logo" :src="logo" :alt="company" class="src mx-auto mt-4 d-block" style="width: 200px;">
        <div class="p-2">
            <router-view></router-view>
        </div>
        <div class="footer-guest">{{ $t('global.multibrain_copyright', {year: (new Date()).getFullYear()}) }}</div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            logo: window.configuration.logo,
            company: window.configuration.company,
        };
    },
}
</script>
<style lang="scss" scoped>
    h1 {
        text-align: center;
    }
    .footer-guest {
        height:20px;
        font-size:14px;
        line-height:14px;
        padding:3px;
        text-align: center;
    }
</style>
